import { render, staticRenderFns } from "./v20a1000.vue?vue&type=template&id=3cc759cd&scoped=true&"
import script from "./v20a1000.vue?vue&type=script&lang=js&"
export * from "./v20a1000.vue?vue&type=script&lang=js&"
import style0 from "./v20a1000.vue?vue&type=style&index=0&id=3cc759cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc759cd",
  null
  
)

export default component.exports